import styled from '@emotion/styled';

import Input from 'storybookConfig/stories/molecules/Input';

const TextAreaInput = styled(Input, {
  shouldForwardProp: (prop) => !['as'].includes(prop),
})<{ as?: 'textarea'; minHeight?: string }>`
  border-radius: ${({ theme }) => theme.radius.xl};
  min-height: ${({ minHeight }) => minHeight || '135px'};
  height: auto;
`;

export default TextAreaInput;
